import * as S from './style'
import * as SG from 'src/components/receivement-components/styles'
import {
  TableHeader,
  Table,
  TableBody,
  TableBodyCell,
} from 'src/components/TableComponents'
import { Product } from 'src/features/receivement/ReceivementTypes'

interface TableOrdersItemsProps {
  ordersItems: Product[]
  onSelected: (args0: Product) => any
  selected?: Product
}

export const TableOrdersItems = ({
  ordersItems,
  onSelected,
  selected,
}: TableOrdersItemsProps) => (
  <S.Wrapper>
    <SG.SubTitle>Pedidos da AR</SG.SubTitle>
    <Table>
      <TableHeader columnInformation={[
        { columnName: 'Código' },
        { columnName: 'Descrição' },
        { columnName: 'Fabricante' },
        { columnName: 'Unidade' },
      ]}
      />
      <TableBody>
        {ordersItems.map((product) => (
          <S.TableBodyRow
            key={product.modelId}
            onClick={() => onSelected(product)}
            clicked={selected?.modelId === product.modelId}
          >
            <TableBodyCell>{product.code}</TableBodyCell>
            <TableBodyCell>{product.description}</TableBodyCell>
            <TableBodyCell>{product.manufacturerName}</TableBodyCell>
            <TableBodyCell>{product.isKg ? 'KG' : 'UN'}</TableBodyCell>
          </S.TableBodyRow>
        ))}
      </TableBody>
    </Table>
  </S.Wrapper>
)
